import { render, staticRenderFns } from "./Fund.vue?vue&type=template&id=47533fa0&"
import script from "./Fund.vue?vue&type=script&lang=ts&"
export * from "./Fund.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports